// extracted by mini-css-extract-plugin
export default {"container":"page-content_container__JSPoW","textContainer":"page-content_textContainer__HyxrE"};